import { MemoryRouter as Router } from 'react-router-dom'
import { Dimmer, Loader } from 'semantic-ui-react'

export const FallbackLoader = () => (
  <Router>
    <Dimmer active>
      <Loader indeterminate>Caricamento...</Loader>
    </Dimmer>
  </Router>
)
